// @flow
import { EyeInvisibleOutlined, EyeOutlined } from "@ant-design/icons";
import { Input } from "./LoginPassword.styles";
import React from "react";
import styled from "styled-components";

interface PasswordInputProps {
	show: boolean;
	register: any;
	name?: string;
}

const PasswordInput = ({
	show,
	onChange,
	value,
	register,
	onClick,
	name = "password",
}: PasswordInputProps) => (
	<Wrapper>
		<Input
			type={show ? "text" : "password"}
			onChange={onChange}
			name={name}
			value={value}
			ref={register({ required: true })}
		></Input>
		<div onClick={onClick}>
			{show ? <EyeInvisibleOutlined /> : <EyeOutlined />}
		</div>
	</Wrapper>
);

const Wrapper = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
`;

export default PasswordInput;
